import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next';

import foto from "../../../media/img/home/innovationFoto.JPG";
import "./innovationDevelopment.scss"

const InnovationDevelopment = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });



        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    return (
        <div>
            <section className='innovation-section'>
                <div className='innovation-section__header'>
                    <h1 className='innovation-section__title'>{t("home.innovation.title")}</h1>
                    <div
                        ref={el => lineRefs.current[0] = el}
                        className="content__title-line"
                    />
                    <p className='innovation-section__description content__text-title-backgroundWhite'>
                        {t("home.innovation.description")}
                    </p>
                </div>

                <div className='innovation-section__grid'>
                    <div className='innovation-section__image-container'>
                        <img
                            className='innovation-section__image'
                            alt="Gestión de proyectos I+D+i"
                            src={foto}
                        />
                    </div>

                    <div className='innovation-section__content'>


                        <h2 className='innovation-section__content-title'>{t("home.innovation.pillarsTitle")}</h2>
                        <p className='innovation-section__content-subtitle'>{t("home.innovation.pillarsSubtitle")}</p>
                        <p className='innovation-section__content-text'>
                            {t("home.innovation.pillarsText")}
                        </p>
                        <ul className='innovation-section__features'>
                            <li className='innovation-section__feature-item'>
                                <span className='innovation-section__feature-icon'>✓</span>
                                {t("home.innovation.aiItem")}
                            </li>
                            <li className='innovation-section__feature-item'>
                                <span className='innovation-section__feature-icon'>✓</span>
                                {t("home.innovation.biItem")}
                            </li>
                            <li className='innovation-section__feature-item'>
                                <span className='innovation-section__feature-icon'>✓</span>
                                {t("home.innovation.autoItem")}
                            </li>
                            <li className='innovation-section__feature-item'>
                                <span className='innovation-section__feature-icon'>✓</span>
                                {t("home.innovation.dataItem")}
                            </li>
                        </ul>

                        <div className="innovation-section__link-conteiner">
                            <a href="/I+D+i" className="innovation-section__link">
                                {t("home.innovation.exploreLink")}
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default InnovationDevelopment;